// extracted by mini-css-extract-plugin
export default {"fade-out":"HomePage_fade-out__SIJS4"};